import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowLeft } from 'react-icons/fi';
import { FaCheckCircle } from 'react-icons/fa';
import LanguageSwitcher from '../../Components/LanguageSwitcher/LanguageSwitcher';
import zoomLogo from '../../assets/zoom-logo.svg';
import styles from './ZoomIntegration.module.css';
import SEO from '../../Components/SEO/SEO';
import { STATIC_PAGE_META } from '../../seo/pageMeta';

const ZoomIntegration = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar' || i18n.language === 'he';

  return (
    <div className={styles.page}>
      <SEO {...STATIC_PAGE_META['zoom-integration']} />
      <div className={styles.container}>
        <div className={styles.topBar}>
          <Link to="/support" className={styles.backButton} aria-label={t('zoom.back')}>
            <FiArrowLeft /> {t('zoom.back')}
          </Link>
          <LanguageSwitcher variant="light" />
        </div>

        <div className={styles.header}>
          <img
            src={zoomLogo}
            alt="Zoom"
            className={styles.zoomLogo}
          />
          <h1 className={styles.title}>{t('zoom.title')}</h1>
          <p className={styles.subtitle}>{t('zoom.subtitle')}</p>
        </div>

        {/* Adding the App */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>{t('zoom.addingTitle')}</h2>
          <p className={styles.sectionBody}>{t('zoom.addingBody')}</p>
          <ol className={styles.stepList} dir={isRtl ? 'rtl' : 'ltr'}>
            {[1, 2, 3, 4, 5].map((n) => (
              <li key={n} className={styles.stepItem}>
                {t(`zoom.addingStep${n}`)}
              </li>
            ))}
          </ol>
          <p className={styles.sectionNote}>{t('zoom.addingNote')}</p>
        </section>

        {/* Usage */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>{t('zoom.usageTitle')}</h2>
          <p className={styles.sectionBody}>{t('zoom.usageBody')}</p>
          <ul className={styles.featureList} dir={isRtl ? 'rtl' : 'ltr'}>
            {[1, 2, 3, 4, 5].map((n) => (
              <li key={n} className={styles.featureItem}>
                <FaCheckCircle className={styles.checkIcon} />
                {t(`zoom.usageFeature${n}`)}
              </li>
            ))}
          </ul>
        </section>

        {/* Removing the App */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>{t('zoom.removingTitle')}</h2>
          <p className={styles.sectionBody}>{t('zoom.removingBody')}</p>
          <ol className={styles.stepList} dir={isRtl ? 'rtl' : 'ltr'}>
            {[1, 2, 3].map((n) => (
              <li key={n} className={styles.stepItem}>
                {t(`zoom.removingStep${n}`)}
              </li>
            ))}
          </ol>
          <div className={styles.warningBox}>
            <p className={styles.warningText}>{t('zoom.removingWarning')}</p>
          </div>
        </section>

        <div className={styles.supportFooter}>
          <p>{t('zoom.needHelp')}</p>
          <Link to="/support" className={styles.supportLink}>{t('zoom.visitSupport')}</Link>
        </div>
      </div>
    </div>
  );
};

export default ZoomIntegration;
